import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-Footer',
  templateUrl: './Footer.component.html'
})
export class FooterComponent implements OnInit {

  constructor( private router: Router) { }

  ngOnInit() {
  }

  public isHActive(id): boolean {
    let obj:any =[];
    if(id==1)
    obj=['/user/dashboard']
   else if(id==2)
    obj=['/user/plancalendar']
    else if(id==3)
    obj=['/user/search']
    else    if(id==4)
    obj=['/user/reports']
    else if(id==5)
    obj=['/user/setting']


    let ret=false;
    obj.map((x)=>{
      if(!ret){
        ret= this.router.url.startsWith(`${x}`);
      }
    })
    return ret;
 }
  
  dashboardPage() {
    this.router.navigate(['/user/dashboard'])
  }

  customerPage() {
    this.router.navigate(['/user/customer'])
  }

  settingPage() {
    this.router.navigate(['/user/setting'])
  }

  profilePage() {
    // this.router.navigate(['/user/profile'])
    this.router.navigate(['/user/reports'])
  }

  reportPage() {
    this.router.navigate(['/user/reports'])
  }

  planPage() {
    this.router.navigate(['/user/plancalendar'])
  }

  searchPage() {
    this.router.navigate(['/user/search'])
  }

}
